<template>
  <b-row class="justify-content-center" no-gutters>
    <b-col cols="12" sm="8" md="6" lg="4" xl="4" class="fit-to-screen bg-white">
      <div class="w-100 bg-white">
        <span id="top-section"></span>
        <div
          class="w-100 position-sticky bg-white bg-white box-shadow-light-aff border-form p-3 position-relative z-index-1040"
          style="top:0;">
          <div class="row align-items-center">
            <div class="col-1 curso-pointer" @click="goToPage('PosHome')">
              <svg width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_581_18)">
                  <path
                    d="M0.0294189 8.00744C0.0294189 8.27112 0.145437 8.5137 0.356381 8.7141L7.35969 15.7069C7.57064 15.9073 7.79213 16.0022 8.04526 16.0022C8.56207 16.0022 8.97341 15.6225 8.97341 15.0951C8.97341 14.842 8.87848 14.5889 8.70973 14.4306L6.34717 12.0259L2.1705 8.21839L1.949 8.7352L5.34519 8.94614H18.6874C19.2358 8.94614 19.6155 8.5559 19.6155 8.00744C19.6155 7.45899 19.2358 7.06874 18.6874 7.06874H5.34519L1.949 7.27969L2.1705 7.80705L6.34717 3.98898L8.70973 1.58422C8.87848 1.41546 8.97341 1.17288 8.97341 0.919749C8.97341 0.392393 8.56207 0.0126953 8.04526 0.0126953C7.79213 0.0126953 7.57064 0.0970726 7.3386 0.32911L0.356381 7.30079C0.145437 7.50118 0.0294189 7.74376 0.0294189 8.00744Z"
                    fill="black" fill-opacity="0.85" />
                </g>
                <defs>
                  <clipPath id="clip0_581_18">
                    <rect width="19.5861" height="16" fill="white" transform="translate(0.0294189 0.0126953)" />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <div class="col-11">
              <div class="w-100 pl-3">
                <div class="border-form radius-6" style="padding-block: 12px;">
                  <div class="row no-gutters">
                    <div class="col-2 lh-1 text-center">
                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_564_18)">
                          <path
                            d="M0 5.66244C0 8.78458 2.54029 11.3249 5.66244 11.3249C6.89709 11.3249 8.02534 10.9275 8.95491 10.2605L12.446 13.7588C12.6092 13.922 12.8221 14 13.0492 14C13.5317 14 13.8652 13.6381 13.8652 13.1627C13.8652 12.9356 13.78 12.7298 13.631 12.5808L10.1611 9.0897C10.8921 8.13887 11.3249 6.95389 11.3249 5.66244C11.3249 2.54029 8.78458 0 5.66244 0C2.54029 0 0 2.54029 0 5.66244ZM1.21338 5.66244C1.21338 3.2073 3.2073 1.21338 5.66244 1.21338C8.11755 1.21338 10.1115 3.2073 10.1115 5.66244C10.1115 8.11756 8.11755 10.1115 5.66244 10.1115C3.2073 10.1115 1.21338 8.11756 1.21338 5.66244Z"
                            fill="black" fill-opacity="0.85" />
                        </g>
                        <defs>
                          <clipPath id="clip0_564_18">
                            <rect width="13.8652" height="14" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                    <div class="col-9 lh-1">
                      <input ref="search_form" type="text" class="w-100 no-focus-border w-100 border-0 body-2-2 pr-2"
                        :disabled="is_load" v-model="search_form">
                    </div>
                    <div class="col-1 lh-1 cursor-pointer" v-if="search_form != ''" @click="clearSearch()">
                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_587_22)">
                          <path
                            d="M0.228308 13.7716C0.537114 14.0717 1.04885 14.0717 1.34883 13.7716L6.99557 8.12491L12.6423 13.7716C12.9423 14.0717 13.4629 14.0805 13.7628 13.7716C14.0628 13.4629 14.0628 12.9599 13.7628 12.66L8.1161 7.0044L13.7628 1.35766C14.0628 1.05767 14.0717 0.545937 13.7628 0.245954C13.454 -0.0628521 12.9423 -0.0628521 12.6423 0.245954L6.99557 5.8927L1.34883 0.245954C1.04885 -0.0628521 0.528291 -0.0716751 0.228308 0.245954C-0.0716751 0.55476 -0.0716751 1.05767 0.228308 1.35766L5.87505 7.0044L0.228308 12.66C-0.0716751 12.9599 -0.0804984 13.4717 0.228308 13.7716Z"
                            fill="black" fill-opacity="0.85" />
                        </g>
                        <defs>
                          <clipPath id="clip0_587_22">
                            <rect width="13.9911" height="14" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <block :height="10"></block>

        <div class="w-100 py-5" v-if="error != ''">
          <ErrorMessage :message="error" />
        </div>
        <template v-else>
          <div class="w-100 py-5" v-if="error != ''">
            <ErrorMessage :message="error" />
          </div>
          <template v-else>
            <div class="mt-5">
              <div class="ga-container">
                <template v-if="is_load">
                  <div class="w-100 mb-4" v-for="i in 5">
                    <div class="row no-gutters">
                      <div class="col-4"> 
                        <div class="w-100 radius-6 position-relative" style="height: 110px;overflow: hidden;">
                          <b-skeleton-img no-aspect height="110px"></b-skeleton-img>
                        </div>
                      </div>
                      <div class="col-8">
                        <div class="pl-3">
                          <b-skeleton width="50%" height="21.3333px" class="mb-1"></b-skeleton>
                          <b-skeleton width="100%" height="16px" class="mb-1"></b-skeleton>
                          <b-skeleton width="30%" height="18px" class="mb-2"></b-skeleton>
                          <b-skeleton width="30%" height="32px" class="d-table ml-auto"></b-skeleton>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div class="w-100 mb-4" v-for="(product,product_i) in product_filtered">
                    <Product type="block" :data="product" :index="product_i" :products_length="products.length"
                      :search_form="search_array" />
                  </div>
                  <div class="text-center" v-if="product_filtered.length == 0">
                    <div class="w-100 mb-3">
                      <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="50%" height="150" viewBox="0 0 888 485.489"
                        xmlns:xlink="http://www.w3.org/1999/xlink">
                        <g>
                          <title>breakfast</title>
                          <path
                            d="M275.41211,460.30048H246.99329a3.76777,3.76777,0,0,0-3.76777,3.76776v12.47387a3.76777,3.76777,0,0,0,3.76777,3.76777h4.70941V499h19V480.30988h4.70941a3.76777,3.76777,0,0,0,3.76776-3.76777V464.06824A3.76777,3.76777,0,0,0,275.41211,460.30048Z"
                            transform="translate(-156 -207.2555)" class="fill-primary" />
                          <path
                            d="M303.87661,574.46128a146.10549,146.10549,0,0,1-25.418-86.62437,3.08142,3.08142,0,0,0-2.40522-3.075V479.372H246.03933v5.315h-.41356a3.07971,3.07971,0,0,0-3.06724,3.30786q3.54683,49.44186-23.95358,88.677a8.4873,8.4873,0,0,0-1.53606,5.14352l3.28188,101.51817a8.78815,8.78815,0,0,0,8.713,8.48191h67.88732a8.79123,8.79123,0,0,0,8.71824-8.63152l1.26471-98.56588A17.78875,17.78875,0,0,0,303.87661,574.46128Z"
                            transform="translate(-156 -207.2555)" fill="#3f3d56" />
                          <path d="M269.48783,464.36493a8.12881,8.12881,0,0,1-16.25763,0" transform="translate(-156 -207.2555)" opacity="0.2" />
                          <path
                            d="M293.12991,608.18244h-8.22064a21.57614,21.57614,0,0,0-42.6488,0h-8.22118a6.06671,6.06671,0,0,0-5.99616,6.98918l8.92944,58.04135h51.27407l10.84608-57.84582A6.0667,6.0667,0,0,0,293.12991,608.18244Z"
                            transform="translate(-156 -207.2555)" class="fill-primary" />
                          <polygon
                            points="827.952 307.634 825.98 386.448 823.538 484.181 740.414 484.181 737.552 369.675 736 307.634 827.952 307.634"
                            fill="#e6e6e6" />
                          <rect x="775.72312" y="265.70393" width="11.76981" height="155.95002" class="fill-primary" />
                          <path
                            d="M978.06676,574.27527l-2.22611,112.02H900.07391l-2.60826-131.24365a51.63393,51.63393,0,0,1,40.82688,5.61536C950.95161,568.15405,965.173,572.18424,978.06676,574.27527Z"
                            transform="translate(-156 -207.2555)" fill="#3f3d56" />
                          <rect x="752.03074" y="379.63032" width="10.79992" height="10.79992" fill="#e6e6e6" />
                          <rect x="759.38688" y="357.56192" width="10.79992" height="10.79992" fill="#e6e6e6" />
                          <rect x="936.42384" y="575.81564" width="10.79992" height="10.79992"
                            transform="translate(375.57517 -653.92108) rotate(36.56259)" fill="#e6e6e6" />
                          <rect x="955.93676" y="594.95132" width="10.79992" height="10.79992"
                            transform="translate(390.81432 -661.77916) rotate(36.56259)" fill="#e6e6e6" />
                          <rect x="922.83416" y="605.98552" width="10.79992" height="10.79992"
                            transform="translate(390.87303 -639.88846) rotate(36.56259)" fill="#e6e6e6" />
                          <circle cx="805.14765" cy="351.03508" r="2.20684" fill="#3f3d56" />
                          <circle cx="760.27524" cy="336.32281" r="2.20684" fill="#3f3d56" />
                          <circle cx="797.79152" cy="320.87493" r="2.20684" fill="#3f3d56" />
                          <circle cx="444.50808" cy="241.75402" r="241.75402" class="fill-primary" />
                          <path
                            d="M600.50808,625.46663a176.45595,176.45595,0,1,1,124.77436-51.68275A175.30352,175.30352,0,0,1,600.50808,625.46663Zm0-342.0314c-91.29808,0-165.5743,74.27621-165.5743,165.57429,0,91.2977,74.27622,165.5743,165.5743,165.5743,91.2977,0,165.57429-74.2766,165.57429-165.5743C766.08237,357.71144,691.80578,283.43523,600.50808,283.43523Z"
                            transform="translate(-156 -207.2555)" opacity="0.2" />
                          <circle cx="444.50808" cy="241.75402" r="171.0157" fill="#3f3d56" />
                          <path
                            d="M473.32742,380.62742a21.704,21.704,0,1,1,38.68118-19.69819l48.31632,94.87836a21.704,21.704,0,1,1-38.68118,19.69819Z"
                            transform="translate(-156 -207.2555)" fill="#ff6584" />
                          <path
                            d="M478.71655,391.21l-2.23-4.379c11.12916-8.64736,24.19788-15.007,38.68118-19.69819l2.23,4.379C501.72232,374.77607,488.38616,380.817,478.71655,391.21Z"
                            transform="translate(-156 -207.2555)" opacity="0.2" />
                          <path
                            d="M489.12314,411.64534l-2.23-4.379c11.12915-8.64736,24.19788-15.007,38.68117-19.69819l2.23,4.379C512.12891,395.21141,498.79275,401.25236,489.12314,411.64534Z"
                            transform="translate(-156 -207.2555)" opacity="0.2" />
                          <path
                            d="M499.52973,432.08068l-2.23-4.379c11.12915-8.64736,24.19788-15.007,38.68118-19.69819l2.23,4.379C522.5355,415.64675,509.19935,421.6877,499.52973,432.08068Z"
                            transform="translate(-156 -207.2555)" opacity="0.2" />
                          <path
                            d="M509.93632,452.516l-2.23-4.379c11.12916-8.64736,24.19788-15.007,38.68118-19.69819l2.23,4.379C532.94209,436.08209,519.60594,442.123,509.93632,452.516Z"
                            transform="translate(-156 -207.2555)" opacity="0.2" />
                          <path
                            d="M520.34292,472.95136l-2.23-4.379c11.12916-8.64736,24.19788-15.007,38.68118-19.69819l2.23,4.379C543.34868,456.51743,530.01253,462.55838,520.34292,472.95136Z"
                            transform="translate(-156 -207.2555)" opacity="0.2" />
                          <path
                            d="M437.07906,416.14643a21.704,21.704,0,1,1,38.68118-19.6982l48.31632,94.87837a21.704,21.704,0,0,1-38.68118,19.69819Z"
                            transform="translate(-156 -207.2555)" fill="#ff6584" />
                          <path
                            d="M442.46819,426.729l-2.23-4.379c11.12916-8.64736,24.19788-15.007,38.68118-19.69819l2.23,4.379C465.474,410.29508,452.1378,416.336,442.46819,426.729Z"
                            transform="translate(-156 -207.2555)" opacity="0.2" />
                          <path
                            d="M452.87478,447.16435l-2.23-4.379c11.12915-8.64736,24.19788-15.007,38.68118-19.69819l2.23,4.379C475.88055,430.73042,462.5444,436.77137,452.87478,447.16435Z"
                            transform="translate(-156 -207.2555)" opacity="0.2" />
                          <path
                            d="M463.28137,467.59969l-2.23-4.379c11.12915-8.64736,24.19788-15.007,38.68118-19.69819l2.23,4.379C486.28714,451.16576,472.951,457.20671,463.28137,467.59969Z"
                            transform="translate(-156 -207.2555)" opacity="0.2" />
                          <path
                            d="M473.688,488.035l-2.23-4.379c11.12916-8.64736,24.19788-15.007,38.68118-19.69819l2.23,4.379C496.69373,471.6011,483.35758,477.64205,473.688,488.035Z"
                            transform="translate(-156 -207.2555)" opacity="0.2" />
                          <path
                            d="M484.09456,508.47037l-2.23-4.379c11.12916-8.64736,24.19788-15.007,38.68118-19.69819l2.23,4.379C507.10032,492.03644,493.76417,498.07739,484.09456,508.47037Z"
                            transform="translate(-156 -207.2555)" opacity="0.2" />
                          <path
                            d="M714.77766,454.45093l.15257.00013a25.8881,25.8881,0,0,0,24.23924-16.23619,84.50284,84.50284,0,0,0,5.9231-31.69393c-.27144-45.91073-37.62223-83.57515-83.52936-84.21021a84.74394,84.74394,0,0,0-35.27687,162.32018,25.66668,25.66668,0,0,0,28.50566-5.28585A84.45815,84.45815,0,0,1,714.77766,454.45093Z"
                            transform="translate(-156 -207.2555)" fill="#e6e6e6" />
                          <circle cx="515.24639" cy="193.55868" r="27.98439" fill="#f9a825" />
                          <circle cx="454.42624" cy="187.11516" r="3.29669" fill="#3f3d56" />
                          <circle cx="345.59806" cy="190.22453" r="3.29669" fill="#3f3d56" />
                          <circle cx="471.99609" cy="152.94948" r="3.29669" fill="#3f3d56" />
                          <circle cx="471.90243" cy="247.97277" r="3.29669" fill="#3f3d56" />
                          <circle cx="537.19934" cy="146.14069" r="3.29669" fill="#3f3d56" />
                          <circle cx="324.20705" cy="236.31261" r="3.29669" fill="#3f3d56" />
                          <circle cx="348.30472" cy="283.7306" r="3.29669" fill="#3f3d56" />
                          <circle cx="499.69951" cy="289.94935" r="12.43751" fill="#ff6584" />
                          <path d="M665.02764,497.9822a9.32813,9.32813,0,0,1-18.65626,0" transform="translate(-156 -207.2555)" opacity="0.2" />
                          <path d="M646.37138,496.42751a9.32813,9.32813,0,0,1,18.65626,0" transform="translate(-156 -207.2555)" opacity="0.2" />
                          <ellipse cx="495.03545" cy="285.67396" rx="0.77734" ry="1.16602" fill="#ff6584" />
                          <ellipse cx="499.69951" cy="284.11927" rx="0.77734" ry="1.16602" fill="#ff6584" />
                          <ellipse cx="499.69951" cy="294.22475" rx="0.77734" ry="1.16602" fill="#ff6584" />
                          <ellipse cx="504.36357" cy="288.00599" rx="0.77734" ry="1.16602" fill="#ff6584" />
                          <ellipse cx="503.58623" cy="296.55678" rx="0.77734" ry="1.16602" fill="#ff6584" />
                          <ellipse cx="494.2581" cy="292.67006" rx="0.77734" ry="1.16602" fill="#ff6584" />
                          <circle cx="524.57452" cy="256.52356" r="12.43751" fill="#ff6584" />
                          <path d="M689.90265,464.5564a9.32813,9.32813,0,0,1-18.65626,0" transform="translate(-156 -207.2555)" opacity="0.2" />
                          <path d="M671.24639,463.00172a9.32813,9.32813,0,0,1,18.65626,0" transform="translate(-156 -207.2555)" opacity="0.2" />
                          <ellipse cx="519.91046" cy="252.24816" rx="0.77734" ry="1.16602" fill="#ff6584" />
                          <ellipse cx="524.57452" cy="250.69348" rx="0.77734" ry="1.16602" fill="#ff6584" />
                          <ellipse cx="524.57452" cy="260.79895" rx="0.77734" ry="1.16602" fill="#ff6584" />
                          <ellipse cx="529.23859" cy="254.5802" rx="0.77734" ry="1.16602" fill="#ff6584" />
                          <ellipse cx="528.46124" cy="263.13098" rx="0.77734" ry="1.16602" fill="#ff6584" />
                          <ellipse cx="519.13311" cy="259.24426" rx="0.77734" ry="1.16602" fill="#ff6584" />
                          <circle cx="549.44953" cy="273.62513" r="12.43751" class="fill-primary" />
                          <path d="M714.77766,481.658a9.32813,9.32813,0,0,1-18.65626,0" transform="translate(-156 -207.2555)" opacity="0.2" />
                          <path d="M696.1214,480.10329a9.32813,9.32813,0,0,1,18.65626,0" transform="translate(-156 -207.2555)" opacity="0.2" />
                          <ellipse cx="544.78547" cy="269.34974" rx="0.77734" ry="1.16602" class="fill-primary" />
                          <ellipse cx="549.44953" cy="267.79505" rx="0.77734" ry="1.16602" class="fill-primary" />
                          <ellipse cx="549.44953" cy="277.90052" rx="0.77734" ry="1.16602" class="fill-primary" />
                          <ellipse cx="554.1136" cy="271.68177" rx="0.77734" ry="1.16602" class="fill-primary" />
                          <ellipse cx="553.33625" cy="280.23255" rx="0.77734" ry="1.16602" class="fill-primary" />
                          <ellipse cx="544.00812" cy="276.34583" rx="0.77734" ry="1.16602" class="fill-primary" />
                          <circle cx="487.262" cy="275.17982" r="12.43751" class="fill-primary" />
                          <path d="M652.59013,483.21266a9.32813,9.32813,0,0,1-18.65626,0" transform="translate(-156 -207.2555)" opacity="0.2" />
                          <path d="M633.93387,481.658a9.32813,9.32813,0,0,1,18.65626,0" transform="translate(-156 -207.2555)" opacity="0.2" />
                          <ellipse cx="482.59794" cy="270.90442" rx="0.77734" ry="1.16602" class="fill-primary" />
                          <ellipse cx="487.262" cy="269.34974" rx="0.77734" ry="1.16602" class="fill-primary" />
                          <ellipse cx="487.262" cy="279.45521" rx="0.77734" ry="1.16602" class="fill-primary" />
                          <ellipse cx="491.92607" cy="273.23646" rx="0.77734" ry="1.16602" class="fill-primary" />
                          <ellipse cx="491.14872" cy="281.78724" rx="0.77734" ry="1.16602" class="fill-primary" />
                          <ellipse cx="481.8206" cy="277.90052" rx="0.77734" ry="1.16602" class="fill-primary" />
                          <circle cx="515.24639" cy="280.62122" r="12.43751" class="fill-primary" />
                          <path d="M680.57452,488.65407a9.32813,9.32813,0,1,1-18.65626,0" transform="translate(-156 -207.2555)" opacity="0.2" />
                          <path d="M661.91826,487.09938a9.32813,9.32813,0,1,1,18.65626,0" transform="translate(-156 -207.2555)" opacity="0.2" />
                          <ellipse cx="510.58233" cy="276.34583" rx="0.77734" ry="1.16602" class="fill-primary" />
                          <ellipse cx="515.24639" cy="274.79114" rx="0.77734" ry="1.16602" class="fill-primary" />
                          <ellipse cx="515.24639" cy="284.89662" rx="0.77734" ry="1.16602" class="fill-primary" />
                          <ellipse cx="519.91046" cy="278.67786" rx="0.77734" ry="1.16602" class="fill-primary" />
                          <ellipse cx="519.13311" cy="287.22865" rx="0.77734" ry="1.16602" class="fill-primary" />
                          <ellipse cx="509.80498" cy="283.34193" rx="0.77734" ry="1.16602" class="fill-primary" />
                          <circle cx="534.68" cy="293.83607" r="12.43751" fill="#ff6584" />
                          <path d="M700.00812,501.86892a9.32812,9.32812,0,1,1-18.65625,0" transform="translate(-156 -207.2555)" opacity="0.2" />
                          <path d="M681.35187,500.31423a9.32812,9.32812,0,1,1,18.65625,0" transform="translate(-156 -207.2555)" opacity="0.2" />
                          <ellipse cx="530.01593" cy="289.56068" rx="0.77734" ry="1.16602" fill="#ff6584" />
                          <ellipse cx="534.68" cy="288.00599" rx="0.77734" ry="1.16602" fill="#ff6584" />
                          <ellipse cx="534.68" cy="298.11147" rx="0.77734" ry="1.16602" fill="#ff6584" />
                          <ellipse cx="539.34406" cy="291.89271" rx="0.77734" ry="1.16602" fill="#ff6584" />
                          <ellipse cx="538.56672" cy="300.4435" rx="0.77734" ry="1.16602" fill="#ff6584" />
                          <ellipse cx="529.23859" cy="296.55678" rx="0.77734" ry="1.16602" fill="#ff6584" />
                          <circle cx="374.73442" cy="246.41808" r="3.29669" fill="#3f3d56" />
                          <polygon points="464.345 366.08 385.17 344.123 388.203 332.857 467.378 354.815 464.345 366.08" fill="#f9a825" />
                          <path d="M608.73806,569.57043a218.26828,218.26828,0,0,1-82.07767,0V557.89212a250.99129,250.99129,0,0,0,82.07767,0Z"
                            transform="translate(-156 -207.2555)" fill="#f9a825" />
                          <path d="M617.17595,534.53552a218.26828,218.26828,0,0,1-82.07767,0V522.85721a250.99184,250.99184,0,0,0,82.07767,0Z"
                            transform="translate(-156 -207.2555)" fill="#f9a825" />
                          <path d="M645.558,548.54948a218.26833,218.26833,0,0,1-82.07768,0v-11.6783a250.9919,250.9919,0,0,0,82.07768,0Z"
                            transform="translate(-156 -207.2555)" fill="#f9a825" />
                          <path d="M652.46168,561.78489a218.26787,218.26787,0,0,1-82.07767,0v-11.6783a250.99184,250.99184,0,0,0,82.07767,0Z"
                            transform="translate(-156 -207.2555)" fill="#f9a825" />
                          <polygon points="520.531 371.824 439.554 385.426 437.676 373.904 518.652 360.302 520.531 371.824" fill="#f9a825" />
                          <path
                            d="M664.43494,580.57677a219.97,219.97,0,0,1-74.58008,34.78439l-4.80446-10.61152a252.95437,252.95437,0,0,0,74.58007-34.78439Z"
                            transform="translate(-156 -207.2555)" fill="#f9a825" />
                          <path
                            d="M657.68866,545.16625a219.96991,219.96991,0,0,1-74.58007,34.78439l-4.80446-10.61152a252.95437,252.95437,0,0,0,74.58007-34.78439Z"
                            transform="translate(-156 -207.2555)" fill="#f9a825" />
                          <path
                            d="M689.24339,545.87182a219.96977,219.96977,0,0,1-74.58008,34.78439l-4.80446-10.61151a252.95471,252.95471,0,0,0,74.58008-34.7844Z"
                            transform="translate(-156 -207.2555)" fill="#f9a825" />
                          <path
                            d="M700.96153,554.97242a219.96991,219.96991,0,0,1-74.58007,34.78439L621.577,579.14529a252.95437,252.95437,0,0,0,74.58007-34.78439Z"
                            transform="translate(-156 -207.2555)" fill="#f9a825" />
                          <rect x="442.95339" y="324.92984" width="3.88672" height="3.88672" fill="#00bf71" />
                          <rect x="454.61355" y="392.55878" width="3.88672" height="3.88672" fill="#00bf71" />
                          <rect x="392.42602" y="324.92984" width="3.88672" height="3.88672" fill="#00bf71" />
                          <rect x="482.59794" y="373.12517" width="3.88672" height="3.88672" fill="#00bf71" />
                          <rect x="484.92997" y="350.5822" width="3.88672" height="3.88672" fill="#00bf71" />
                          <rect x="574.85572" y="545.40019" width="5.44141" height="3.10938"
                            transform="translate(250.70796 -437.19066) rotate(34.15572)" fill="#00bf71" />
                          <rect x="620.71902" y="553.95098" width="5.44141" height="3.10938"
                            transform="translate(263.41949 -461.46545) rotate(34.15572)" fill="#00bf71" />
                          <rect x="564.75025" y="568.72051" width="5.44141" height="3.10938"
                            transform="translate(262.05797 -427.49459) rotate(34.15572)" fill="#00bf71" />
                          <rect x="596.62136" y="565.61114" width="5.44141" height="3.10938"
                            transform="translate(1249.17714 182.37779) rotate(124.15572)" fill="#00bf71" />
                          <rect x="617.60965" y="571.05255" width="5.44141" height="3.10938"
                            transform="translate(1286.45203 173.50612) rotate(124.15572)" fill="#00bf71" />
                          <rect x="673.57842" y="552.39629" width="5.44141" height="3.10938"
                            transform="matrix(-0.56144, 0.82751, -0.82751, -0.56144, 1358.40581, 98.06043)" fill="#00bf71" />
                          <rect y="483.24828" width="888" height="2.24072" fill="#3f3d56" />
                        </g>
                      </svg>
                    </div>
                    <div class="w-85 mx-auto">
                      <p class="heading-6-1 mb-2">Oops, No Bites Found!</p>
                      <p class="body-2-2 mb-0">Don't worry, our menu's full of surprises. Keep exploring, your next favorite dish is just a click away!</p>
                    </div>
                  </div>
                </template>
              </div>
              <block :height="100"></block>
              <FloatOrderSummary/>
            </div>
          </template>
        </template>
      </div>
    </b-col>
  </b-row>
</template>

<script>
  import {
    mapGetters
  } from 'vuex'
  import {
    get
  } from '@/services/index.js'
  import Product from '../../../../components/hotel/concierge/pos/Product';
  import FloatOrderSummary from '@/components/hotel/concierge/pos/FloatOrderSummary';

  export default {
    components: {
      Product,
      FloatOrderSummary
    },
    data() {
      return {
        is_load: true,
        error: '',
        products: [],
        search_form: ''
      }
    },
    metaInfo() {
      return {
        title: 'Search',
        titleTemplate: this.getMetaTitleTemplate
      }
    },
    computed: {
      ...mapGetters(['getMerchant','getMetaTitleTemplate']),
      pos_id() {
        return this.$route.query.pos_id
      },
      pos_code() {
        return this.$route.params.pos_code
      },
      product_filtered() {
        let return_data = []

        if (this.products.length > 0) {
          if (this.search_form == '') {
            return_data = this.products
          } else {
            let copied_data = this.$deepCopy(this.products)
            return_data = copied_data.filter(item => {
              let is_name_matched = item.name.toString().toLowerCase().match(this.search_form.toLowerCase())
              let is_desc_matched = item.description.toString().toLowerCase().match(this.search_form.toLowerCase())
              return is_name_matched || is_desc_matched
            })
          }
        }

        return return_data
      },
      search_array() {
        let return_data = this.search_form.split(" ")
        return return_data
      }
    },
    mounted() {
      this.$smoothScroll('top-section')
      this.loadFirstData()
    },
    methods: {
      loadFirstData() {
        this.is_load = true
        this.error = ''
        Promise.all([
            this.loadProductList()
          ])
          .catch(err => {
            this.error = err
          })
          .finally(() => {
            this.is_load = false
            this.$nextTick(() => {
              this.$refs.search_form.focus()
            })
          })
      },
      loadProductList() {
        return new Promise((success, fail) => {
          get("CORE_HOTEL", `merchant-pos/${this.pos_id}/product`, {
            merchant_id: this.getMerchant.id,
            page_size: 1000
          }).then(response => {
            let res = response.data
            if (res.success) {
              this.products = res.data
              success()
            } else {
              fail(res.message)
            }
          })
        })
      },
      goToPage(page) {
        let route = {
          name: page,
          params: {
            merchant_code: this.getMerchant.code,
            pos_code: this.pos_code
          }
        }
        this.$router.push(route)
      },
      clearSearch(){
        this.search_form = ''
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/pages/hotel/concierge/pos/Search.vue